import { proxy } from 'valtio';
import type { ProjectWithDetails } from '~/pages/projectDetails/details/common';

export interface Project extends ProjectWithDetails {
  address2: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    crossStreets: string;
  };
}

class Store {
  project?: Project;

  setProject(project: Project) {
    this.project = project;
  }

  reset() {
    this.project = undefined;
  }
}

const store = proxy(new Store());
export default store;
